import React from 'react';
import { ControlledRadioGroup } from 'src/components/BeaconV2Components/common/ControlledRadioGroup';
import { brandsCategories } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/constants';
import { usePresentationFormContext } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Presentations/PresentationFormContext';

export const PresentationsBrandsPage = () => {
  const { brands: { control } } = usePresentationFormContext();

  return (
    <ControlledRadioGroup
      control={control}
      name="brandGroupings"
      options={brandsCategories}
      label="Brand Highlights"
      description="This presentation will highlight additional insights for the brands selected below."
    />
  );
};
